export enum ProductLifecycleStatus {
    Draft = "Draft",
    Active = "Active",
    Completed = "Completed",
    Cancelled = "Cancelled",
}
